import { Api } from "../helpers";
import { IOsrmRouteResponse, IOsrmSnapMatchResponse } from "../models";

export class OsrmApi {
  static async getSnapMatchedPolyline(
    points: number[][],
  ): Promise<IOsrmSnapMatchResponse | undefined> {
    const coords = points.map(([lng, lat]) => `${lng},${lat}`).join(";");

    const requestUrl = `/api/v1/core/info/osrm/match/v1/driving/${coords}?geometries=polyline&steps=false`;

    const response = await Api.get<IOsrmSnapMatchResponse | undefined>(
      requestUrl,
    );

    return response?.data;
  }

  /** Road-following route (encoded polyline) through the given waypoints — same OSRM service the map routing uses. */
  static async getRoutePolyline(
    points: number[][],
  ): Promise<string | undefined> {
    const coords = points.map(([lng, lat]) => `${lng},${lat}`).join(";");

    const requestUrl = `/api/v1/core/info/osrm/route/v1/driving/${coords}?overview=full&geometries=polyline`;

    const response = await Api.get<IOsrmRouteResponse | undefined>(requestUrl);

    return response?.data?.routes?.[0]?.geometry;
  }
}
